import { http } from "@/lib/http";

const SESSION_STORAGE_PREFIX = "fanvault:tenant-page-analytics-session:";
const LAST_SENT_PREFIX = "fanvault:tenant-page-analytics-last:";

function buildSessionStorageKey(tenantSlug: string) {
  return `${SESSION_STORAGE_PREFIX}${tenantSlug}`;
}

function buildLastSentKey(tenantSlug: string, path: string) {
  return `${LAST_SENT_PREFIX}${tenantSlug}:${path}`;
}

function randomId() {
  return `${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
}

function getSessionId(tenantSlug: string) {
  const storageKey = buildSessionStorageKey(tenantSlug);
  const existing = window.localStorage.getItem(storageKey);

  if (existing) {
    return existing;
  }

  const created = randomId();
  window.localStorage.setItem(storageKey, created);
  return created;
}

export async function trackTenantPageView(tenantSlug: string, path: string, pageName?: string) {
  if (!tenantSlug || !path) {
    return;
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const lastSentKey = buildLastSentKey(tenantSlug, normalizedPath);
  const now = Date.now();
  const lastSentAt = Number(window.sessionStorage.getItem(lastSentKey) ?? 0);

  if (lastSentAt && now - lastSentAt < 5000) {
    return;
  }

  window.sessionStorage.setItem(lastSentKey, String(now));

  try {
    await http.post("/api/v1/analytics/page-views", {
      path: normalizedPath,
      page_name: pageName || undefined,
      session_id: getSessionId(tenantSlug),
    });
  } catch {
    // Tracking failures should never block navigation.
  }
}
